import { computed } from '@vue/composition-api'
import { page } from '@iez/core'
import router from '@iez/core/router/'
import { mdiCharity, mdiCog, mdiAccountEdit, mdiLogout, mdiShieldStar, mdiHandHeart, mdiInformation } from '@mdi/js'
import firebase from 'firebase/app'
import user from '@iez/lib/user/'
import { noop } from 'lodash'
import waitFor from '@iez/lib/wait-for/'
import createOnClick from '@iez/lib/create-on-click/'

export default ({ isAdmin, isAssociation }) => {
  /* const choiceSwitchTheme = computed(
    () => ({
      label: theme.dark
        ? `Passer en thème clair`
        : `Passer en thème sombre`,
      icon: mdiThemeLightDark,
      onClick: () => {
        theme.dark = !theme.dark
      }
    })
  ) */

  const choiceEditProfile = {
    label: 'Modifier le profil',
    icon: mdiAccountEdit,
    onClick: createOnClick({
      editProfile: () => {
        router.push({ name: 'ProfileEdit' })
        page.blockingMenu.dismiss()
      }
    })
  }
  const choiceMyAds = {
    label: `Mes annonces`,
    icon: mdiCharity,
    onClick: createOnClick({
      myAds: () => {
        router.push({ name: `MyAds` })
        page.blockingMenu.dismiss()
      }
    })
  }
  const choiceManageYako = computed(
    () => isAdmin.value ? {
      label: `Gérer Yako`,
      icon: mdiShieldStar,
      onClick: createOnClick({
        manageYako: () => {
          router.push({ name: 'ManageYako' })
          page.blockingMenu.dismiss()
        }
      })
    } : null
  )
  const choiceLogout = {
    label: 'Se déconnecter',
    icon: mdiLogout,
    onClick: createOnClick({
      logout: async () => {
        // TODO reset le store
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            name: `logout`
          }))
        } else {
          firebase.auth().signOut()
        }
        await waitFor({
          dependencies: () => !user.id
        })
        page.blockingMenu.dismiss()
        router.replace({
          name: `Home`
        }).catch(noop)
      }
    })
  }
  const choiceReceivedSupports = computed(
    () => isAssociation.value
      ? {
      label: `Mes soutiens`,
      icon: mdiHandHeart,
      onClick: createOnClick({
        receivedSupports: () => {
          router.push({
            name: `ReceivedSupports`
          })
        }
      })
    } : null
  )

  const choiceAbout = {
    label: `À propos`,
    icon: mdiInformation,
    onClick: createOnClick({
      about: () => {
        const url = `https://yako.co/a-propos/`
        open(url, `_blank`).focus()
      }
    })
  }
  const choiceSettings = {
    label: `Paramètres`,
    icon: mdiCog,
    onClick: createOnClick({
      settings: () => {
        router.push({
          name: `Settings`
        })
      }
    })
  }

  const items = computed(() => [
    choiceEditProfile,
    choiceMyAds,
    choiceReceivedSupports.value,
    choiceManageYako.value,
    /* choiceSwitchTheme.value, */
    choiceSettings,
    choiceAbout
  ].filter(Boolean))

  const itemBottom = choiceLogout

  return {
    items,
    itemBottom
  }
}
